import script from "./PollForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PollForm.vue?vue&type=script&setup=true&lang=js"

import "./PollForm.vue?vue&type=style&index=0&id=0fee28af&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fee28af"]])

export default __exports__